/**
 * @generated SignedSource<<16ce8ed6e7faa0da02eb1903062c7bd1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AbandonCheckoutModal_item$data = {
  readonly localizedPdpUrl: string | null;
  readonly " $fragmentType": "AbandonCheckoutModal_item";
};
export type AbandonCheckoutModal_item$key = {
  readonly " $data"?: AbandonCheckoutModal_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"AbandonCheckoutModal_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AbandonCheckoutModal_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "localizedPdpUrl",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "22e0c06a4e77306aec3bb24c579c5249";

export default node;
